import axios, { AxiosResponse } from 'axios';

import { apiUrl } from '@/config/api';

import { ApiGroupsList } from './types/groups';

const list = (token: string): Promise<AxiosResponse<ApiGroupsList>> => {
    return axios.post(`${apiUrl}/trk/common/group/detail/list`, null, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });
};

export default {
    list,
};
